export { default } from './EmptyTable';
